import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { compose } from 'recompose';
import { withLayout } from 'hocs';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as AuthActions } from 'store/ducks/auth';

import { Access } from 'common';
import { LoadingScreen } from 'components';

class PrivateRoute extends Component {
  static defaultProps = {
    permissions: null,
  };

  state = {
    loading: true,
  };

  componentDidMount() {
    const { getAuthUserRequest } = this.props;

    getAuthUserRequest();
  }

  componentDidUpdate(oldProps) {
    const { user } = this.props;

    if (oldProps.user.loading && !user.loading) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading } = this.state;
    const { user, permissions } = this.props;
    const RenderComponent = this.props.component;

    return loading ? (
      <LoadingScreen />
    ) : (
      <Route
        render={props =>
          Access.hasPermissions(permissions) ? (
            user.data.id ? (
              <RenderComponent {...props} />
            ) : (
              <Redirect to="/login" />
            )
          ) : (
            <Redirect to="/" />
          )
        }
      />
    );
  }
}

const mapState = state => ({
  user: state.auth.user,
});

const mapActions = dispatch => bindActionCreators(AuthActions, dispatch);

export default compose(
  connect(
    mapState,
    mapActions,
  ),
  withLayout(),
)(PrivateRoute);
